module.exports = __webpack_public_path__ + "static/img/slogan1.01eb851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slogan1.png
// module id = jjJD
// module chunks = 1